"use client";

import { ReactNode } from "react";
import Image from "next/image";

import type { GetStartedStep } from "../types";

type PreviewCardProps = {
    steps: GetStartedStep[];
    activeIndex: number;
    productBadge?: ReactNode;
};

const PreviewCard = ({ steps, activeIndex, productBadge }: PreviewCardProps) => {
    return (
        <div className="relative w-full h-full overflow-hidden bg-[linear-gradient(180deg,_#19223D_2.38%,_#2A3966_39.12%,_#A9B9E5_161.17%)]">
            {steps.map((step, index) => (
                <div
                    key={step.id}
                    aria-hidden={index !== activeIndex}
                    className="absolute bottom-0 left-1/2 aspect-[403/338] w-[403px] -translate-x-1/2 bg-pureWhite/90 rounded-t-2xl overflow-hidden transition-opacity duration-300 ease-out shadow-[0_-1.896px_15.828px_-1.896px_rgba(0,0,0,0.07),0_-1.896px_5.687px_-0.948px_rgba(0,0,0,0.05)]"
                    style={{ opacity: index === activeIndex ? 1 : 0 }}
                >
                    <Image
                        src={step.image.desktop.url}
                        alt={step.image.desktop.alt}
                        fill
                        sizes="50vw"
                        quality={95}
                        className="object-cover object-center"
                    />
                </div>
            ))}
            {productBadge && (
                <div className="absolute bottom-0 left-1/2 aspect-[403/338] w-[403px] -translate-x-1/2 pointer-events-none z-10">
                    <div className="absolute top-[22px] left-[22px] w-[160px]">
                        {productBadge}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PreviewCard;
